import { CellContext } from "@tanstack/react-table";
import { memo } from "react";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { TransactionAction } from "../TransactionAction";
import { ActionsColumn } from "../../../common/types/views/transactionViews";
import { RequiredAction } from "../../../common/requiredActions";

export const ActionsCell = memo(
    ({ row, column }: CellContext<TransactionListItemDto, any>) => {
        const meta: ActionsColumn["options"] = column.columnDef.meta ?? {};
        const visibleRequiredActions = meta.requiredActions as RequiredAction[];

        return (
            <TransactionAction
                transaction={row.original}
                visibleRequiredActions={visibleRequiredActions}
            />
        );
    },
);
